<template lang="pug">
	.material-links
		ListView.full-width(ref="listView", initialView="table", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :getData="getMaterialLinks",
			:columns="columns"
		)
			template(v-slot:oid-cell-template="{ data }")
				.flex-row.space.align-center
					DxButton(icon="close", @click="deleteMaterialLink(data)")
			template(slot="left-actions")
				.flex-row.space.align-center
					.font-large External materials
					DxButton(icon="plus", @click="materialLinksPopup = true")
		Popup(v-if="materialLinksPopup" :popupVisible="materialLinksPopup" :width="460" :height="420" :closeOnOutsideClick="false")
			h2 External material
			.flex-row.space-large
				.flex-col.space-large.flex-1
					.field
						.font-small.upper.grey Station owner
						Dropdown(
							:getTotal="(data) => null", :getItems="(data) => data.Results", :getData="(a,b,c) => $Data.getExternalCompanies(a,b, {...(c || {}), byType: 1, forceTokenAuth: c.byKey ? false : null })",
							:columns="[{ dataField: 'Name', caption: 'Station owner' }]",
							displayExpr="Name",
							valueExpr="Oid",
							:showColumnHeaders="false",
							:filtersVisible="false",
							:searchVisible="true",
							:multiple="false",
							:minSearchLength="0",
							@select-data="item => materialLink.StationOwnerId = item.Oid")
					.field
						.font-small.grey.upper Station
						Dropdown.selector(v-if="",
							:getTotal="r => r.TotalNumberOfRecords", :getItems="(data) => data.Results", :getData="(a,b,c) => $Data.getExternalStations(a,b,{...c, allCountries: true })",
							:columns="[{ dataField: 'Name', caption: 'Station' }]",
							displayExpr="Name",
							valueExpr="Oid",
							:showColumnHeaders="false",
							:filtersVisible="false",
							:searchVisible="true",
							:multiple="false",
							:minSearchLength="0",
							@select-data="v => materialLink.StationId = v.Oid")
					.field
						.font-small.grey.upper Material ID
						DxTextBox(:value.sync="materialLink.MaterialId")
							dx-validator
								dx-required-rule
			template(slot="actions-right")
				DxButton(text="Save", type="success", @click="createMaterialLink" :disabled="disabled || loading")
				DxButton(text="Cancel", @click="materialLinksPopup = false")
</template>

<script>
	import DxTextBox from 'devextreme-vue/text-box';
	import DxButton from 'devextreme-vue/button';
	import ListView from 'app-core/ListView.vue';
	import Popup from 'app-core/Popup.vue';
	import Dropdown from 'app-core/Dropdown.vue';
	import DxValidator, { DxRequiredRule } from 'devextreme-vue/validator';

	export default {
		translationCategory: 'creative.MaterialLinks',
		name: 'material-links',
		props: {
			creative: Object,
		},
		components: {
			ListView, DxButton, Popup, DxTextBox, DxValidator, DxRequiredRule, Dropdown
		},

		data() {
			return {
				loading: false,
				columns: [
					{ dataField: 'Oid', caption: '', cellTemplate: 'oid-cell-template' },
					{ dataField: 'CreativeName', caption: 'Creative' },
					{ dataField: 'StationOwnerName', caption: 'Station owner' },
					{ dataField: 'StationName', caption: 'Station' },
					{ dataField: 'MaterialId', caption: 'Material ID' }
				],
				materialLinksPopup: false,
				materialLink: {
					StationOwnerId: null,
					StationId: null,
					MaterialId: '',
				}
			}
		},
		computed: {
			disabled() {
				return this.materialLink.StationOwnerId === null || this.materialLink.StationId === null || this.materialLink.MaterialId === ''
			}
		},
		mounted() {
			this.getMaterialLinks();
		},
		methods: {
			getMaterialLinks() {
				return this.$Data.getMaterialLinks(this.creative.Oid, 0);
			},
			createMaterialLink() {
				this.loading = true;
				const params = [{...this.materialLink, CreativeId: this.creative.Oid}];
				this.$Data.postExternalApi('Creative/CreateUpdateMaterialLinks', params).then(() => {
					this.$refs.listView.reload();
				}).finally(() => {
					this.loading = false;
					this.materialLinksPopup = false;
					this.materialLink = {
						StationOwnerId: null,
						StationId: null,
						MaterialId: '',
					}
				});
			},
			deleteMaterialLink(data) {
				this.$Data.postExternalApi('Creative/DeleteMaterialLinks', [data.Oid]).then(r => {
					if (r.Success) {
						this.$refs.listView.reload();
					} else {
						this.$notifyError(r.ErrorMessage);
					}
				})
			}
		}
	};
</script>
<style lang='scss'>

</style>
